// Port of api/fuel/app/classes/filter/search/games/filters/query/play/date/last.php
export default {
	name: 'play.date.last',
	priority: 57,
	require: function(config, filter) {
		return filter.played && (
			(filter.played.last && (filter.played.last.from || filter.played.last.to)) ||
			(filter.played.sometime && (filter.played.sometime.from || filter.played.sometime.to) && filter.play && filter.play.last)
		)
	},
	run: function(config, filter, data, query) {
		if (filter.played.last.from) query.having('MAX(p.play_date)', '>=', filter.played.last.from)
		if (filter.played.last.to) query.having('MAX(p.play_date)', '<=', filter.played.last.to)
		if (filter.played.sometime.from) query.having('MAX(p.play_date)', '>=', filter.played.sometime.from)
		if (filter.played.sometime.to) query.having('MAX(p.play_date)', '<=', filter.played.sometime.to)
	}
}
